import {z} from "zod";
import {FileModel} from "../FileModel";
import {TaxAccountantNameModel} from "../TaxAccountantNameModel";
import {CONSULTATION_KEY_TYPE, CONSULTATION_TARGET_KEY_TYPE} from "../common/enum";
import {RECOMMENDED_CUSTOMER_INFO} from "../tax-accountant/form";

export const visitHistoryFormSchema = z.object({
	department: z.string(), // 부서 - 자동입력
	managerId: z.string(), // 담당자 - 자동입력
	taxAccountantId: TaxAccountantNameModel.model.nullable(), // 세무사
	visitedAt: z.string(), // 면담일시 - YYYY-MM-dd HH:mm
	wroteDate: z.string(), // 작성일자 - 자동입력
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(), // 유형
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable(), // 구분
	content: z.string().nullable(),
	files: z.array(FileModel.model),
	recommendedTaxAccountantId: TaxAccountantNameModel.model.nullable(), // 추천 세무사 - 추천이 있는 경우
	recommendedCustomers: z.array(RECOMMENDED_CUSTOMER_INFO)
});

export type VisitHistoryFormType = z.infer<typeof visitHistoryFormSchema>;
